import { Modal } from "bootstrap";

import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import Select from "react-select";

import {
    useForm,
    Controller,
} from "react-hook-form";

import { toast } from "react-toastify";

// import * as b2cleadService from "../../Services/b2cleadService";
import * as b2bleadService from "../../Services/b2bleadService";

const B2BActivityLeadTypeModal = forwardRef(
    (props, ref) => {

        const {
            leadDetails,
            getLeadData,
        } = props;

        const {
            control,
            handleSubmit,
            reset,
            formState: { errors },
        } = useForm({
            mode: "onSubmit",
        });

        const modalRef = useRef(null);

        const bsModal = useRef(null);

        const [submitLoader, setSubmitLoader] =
            useState(false);

        // CLOSE
        const handleClose = () => {

            reset();

            bsModal.current?.hide();

        };

        // MODAL HANDLE
        useImperativeHandle(ref, () => ({

            toggle() {

                if (!bsModal.current) {

                    bsModal.current =
                        new Modal(
                            modalRef.current
                        );

                }

                bsModal.current.show();

            },

            close() {

                handleClose();

            },

        }));

        // OPTIONS
        const leadTypeOptions = [

            {
                label: "Hot",
                value: "Hot",
            },

            {
                label: "Cold",
                value: "Cold",
            },

            {
                label: "Warm",
                value: "Warm",
            },

        ];

        // SUBMIT
        const onSubmit = async (
            data
        ) => {

            setSubmitLoader(true);

            try {

                const body = {
                    leadType:
                        data?.leadType?.value,
                };

                const res =
                    await b2bleadService.addLeadType(
                        leadDetails?.id,
                        body
                    );

                if (
                    res?.data?.status ===
                    "success"
                ) {

                    toast.success(
                        res?.data?.message
                    );

                    handleClose();

                    getLeadData();

                } else {

                    toast.error(
                        res?.data?.message
                    );

                }

            } catch (error) {

                console.log(
                    "LEAD TYPE ERROR",
                    error
                );

                toast.error(
                    "Failed To Update Lead Type"
                );

            } finally {

                setSubmitLoader(false);

            }

        };

        return (

            <div
                className="modal fade"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background:
                        "rgba(15,23,42,0.55)",

                    backdropFilter:
                        "blur(5px)",
                }}
            >

                <div className="modal-dialog modal-lg modal-dialog-centered">

                    <div className="modal-content border-0 rounded-4 ">

                        {/* HEADER */}
                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "rgb(94, 44, 158)",
                            }}
                        >

                            <div>

                                {/* <h5 className="fw-bold mb-1">

                                    Lead Type

                                </h5> */}

                                <p className="mb-0 small opacity-75">

                                    Update lead type

                                </p>

                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={
                                    handleClose
                                }
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>

                        {/* FORM */}
                        <form
                            onSubmit={handleSubmit(
                                onSubmit
                            )}
                        >

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row g-4">

                                    {/* LEAD TYPE */}
                                    <div className="col-md-12">

                                        <label className="form-label fw-semibold">

                                            Select Lead Type

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <Controller
                                            name="leadType"
                                            control={
                                                control
                                            }
                                            rules={{
                                                required:
                                                    "Please select atleast one lead type",
                                            }}
                                            render={({
                                                field,
                                            }) => (

                                                <Select
                                                    {...field}
                                                    placeholder="Select Lead Type"
                                                    options={
                                                        leadTypeOptions
                                                    }
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    value={
                                                        field.value || null
                                                    }
                                                    isClearable
                                                    isSearchable
                                                />

                                            )}
                                        />

                                        {errors.leadType && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .leadType
                                                        .message
                                                }

                                            </small>

                                        )}

                                    </div>

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0 px-4 pb-4">

                                <button
                                    type="button"
                                    className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                    onClick={
                                        handleClose
                                    }
                                >

                                    Close

                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                    disabled={
                                        submitLoader
                                    }
                                >

                                    {submitLoader
                                        ? "Saving..."
                                        : "Save"}

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

        );

    }
);

export default B2BActivityLeadTypeModal;